import { FC } from "react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { MessageTemplateButtons } from "./MessageTemplateButtons";
import { MESSAGE_TEMPLATES } from "./MessageTemplates";

interface TemplateMessageSectionProps {
  messageTemplate: string;
  onMessageTemplateChange: (value: string) => void;
  onFormatText: (format: "bold" | "italic") => void;
  onInsertEmoji: (emoji: string) => void;
}

export const TemplateMessageSection: FC<TemplateMessageSectionProps> = ({
  messageTemplate,
  onMessageTemplateChange,
  onFormatText,
  onInsertEmoji,
}) => {
  return (
    <div className="space-y-2 bg-[#DCF8C6] dark:bg-[#025C4C] rounded-lg p-4">
      <Label htmlFor="template" className="text-lg font-bold text-[#075E54] dark:text-[#E9EDF0]">
        Template Pesan
      </Label>
      <Select
        value={messageTemplate}
        onValueChange={onMessageTemplateChange}
      >
        <SelectTrigger className="w-full text-lg bg-white dark:bg-[#1F2C34] border-2 border-[#25D366] dark:border-[#00A884] focus:border-[#128C7E]">
          <SelectValue placeholder="Pilih template pesan" />
        </SelectTrigger>
        <SelectContent>
          {Object.entries(MESSAGE_TEMPLATES).map(([key, value]) => (
            <SelectItem key={key} value={value}>
              {value}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <MessageTemplateButtons
        onFormatText={onFormatText}
        onInsertEmoji={onInsertEmoji}
      />
      <Textarea
        id="template"
        value={messageTemplate}
        onChange={(e) => onMessageTemplateChange(e.target.value)}
        className="text-lg bg-white dark:bg-[#1F2C34] border-2 border-[#25D366] dark:border-[#00A884] focus:border-[#128C7E] min-h-[120px]"
      />
    </div>
  );
};